import {companyLink} from "./companyLink";

const creator1 = {
    image:'/img/blog/juli.jpg',
    name:'Juli Kumari',
    role:'Founder & CEO',
    socialLink:{...companyLink}
}
const creator2 = {
    image:'/img/blog/utkarsh_bansal.jpg',
    name:'Utkarsh Bansal',
    role:'Product Manager',
    socialLink:{...companyLink}
}
const creator3= {
    image:'/img/blog/abhishek.jpg',
    name:'Abhishek',
    role:'CTO',
    socialLink:{...companyLink}
}
const creator4= {
    image:'/img/blog/blog-author.jpg',
    name:'Ravi Bharti',
    role:'Softare Developer',
    socialLink:{...companyLink}
}

export {creator1,creator2,creator3,creator4}